import { ActionIcon, Text } from "@mantine/core";
import { Mic, Square } from "lucide-react";

import { clock } from "../../ui/AudioPlayer";
import { useRecorder } from "./use-recorder";
import classes from "./voices.module.css";

export interface AudioRecorderProps {
  /** Live's words above the microphone, as the form has them. */
  title: string;
  description: string;
  /** The rule under them: Create Voice's length, a talking head's formats and length. */
  hint: string;
  disabled?: boolean;
  onRecorded: (file: File) => void;
}

/**
 * Live's recorder (`audio-record`, captures L02b and LEFTOVERS 9): its words, the round
 * microphone that starts and stops, and the timer. Create Voice and the Talking Head's Speech
 * take it, each with its own words.
 */
export function AudioRecorder(props: AudioRecorderProps) {
  const { title, description, hint, disabled = false, onRecorded } = props;
  const recorder = useRecorder(onRecorded);
  const recording = recorder.state === "recording";
  return (
    <div className={classes.recorder}>
      <Text className={classes.recorderTitle}>{title}</Text>
      <Text className={classes.small}>{description}</Text>
      {hint === "" ? null : <Text className={classes.small}>{hint}</Text>}
      <ActionIcon
        variant="filled"
        size={48}
        radius="xl"
        disabled={disabled}
        aria-label={recording ? "Stop recording" : "Start recording"}
        loading={recorder.state === "processing"}
        onClick={() => (recording ? recorder.stop() : void recorder.start())}
      >
        {recording ? <Square size={20} /> : <Mic size={20} />}
      </ActionIcon>
      <Text size="sm">{clock(recorder.seconds)}</Text>
      {recorder.problem === null ? null : (
        <Text className={classes.problem} role="alert">
          {recorder.problem}
        </Text>
      )}
    </div>
  );
}
